import { Injectable } from '@angular/core';
const io = require('socket.io-client');
import { Observable } from 'rxjs';
import { Config } from '../universal-config';

@Injectable()
export class SocketIoService {
  socket = null;
  messages$;
  messagesObserver;
  isSocketConnected$;
  connectionObserver;

  constructor(
    public config: Config,
  ) {
    this.messages$ = new Observable<any>((observer) => {
      this.messagesObserver = observer;
      return () => {
        this.disconnect();
      };
    });

    this.isSocketConnected$ = new Observable<any>((observer) => {
      this.connectionObserver = observer;
      return {unsubscribe() {}};
    });
  }

  public getMessages() {
    return this.messages$;
  }

  public getIsConnected() {
    return this.isSocketConnected$;
  }

  connect() {
    const { origin } = window.location;
    const secure = this.config.get('SERVER_SECURE');
    this.socket = io.connect(origin, { secure, transports: ['websocket'] });


    this.socket.on("job:success", (event) => {
      const message = {
        eventName: "job:success",
        data: event
      };
      this.messagesObserver.next(message);
    });

    this.socket.on("job:error", (event) => {
      const message = {
        eventName: "job:error",
        data: event
      };
      this.messagesObserver.next(message);
    });

    this.socket.on("connect",() => {
      this.connectionObserver.next(true);
    })

    this.socket.on("disconnect", () => {
      this.connectionObserver.next(false);
    })
  }

  disconnect() {
    if (this.socket) {
      this.socket.close();
    }
    this.socket = null;
  }
}

@Injectable()
export class SocketIoServiceMockServer {
  socket;

  public getMessages() {
    return null;
  }

  public getIsConnected() {
    return null;
  }

  public connect() {
    return null;
  }
  public disconnect() {
    return null;
  }
}
